module.exports = __webpack_public_path__ + "img/just-eat-orange-logo.93fa2971.png";